import { TextInput } from '@loomhq/lens';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import EMOJI_REACTIONS_MAP from 'constants/emojiReactions';
import { ENTER } from 'constants/keyCodes';
import { updateUsername } from 'creators/videoPlayer';
import { getAnonUserName } from 'utilities/auth';

import { selectUserIsLogged } from 'selectors/user';
import {
  selectCommentsEnabled,
  selectEmojiEnabled,
  selectRolloutTimelineComments,
} from 'selectors/video';
import { selectHasEnded, selectHasStarted } from 'selectors/videoPlayer';

import EmojiIconButton from './emoji-icon-button';

import CommentButton from 'components/ui-components/comment-button';
import ConditionalTooltip from 'components/ui-components/conditional-tooltip';

import styles from './styles.module.less';

const filterNervous = type => type != 'nervous';

const EngagementBar = () => {
  const dispatch = useDispatch();

  const emojiEnabled = useSelector(selectEmojiEnabled);
  const rolloutTimelineComments = useSelector(selectRolloutTimelineComments);
  const commentsEnabled = useSelector(selectCommentsEnabled);
  const isLoggedIn = useSelector(selectUserIsLogged);

  const videoHasEnded = useSelector(selectHasEnded);
  const videoHasStarted = useSelector(selectHasStarted);

  const componentDisabled = !videoHasStarted || videoHasEnded;
  const showCommentButton = commentsEnabled && rolloutTimelineComments;

  const [askForName, setAskForName] = useState(false);
  const [anonName, setAnonName] = useState('');

  function checkAnonName() {
    if (!isLoggedIn && !getAnonUserName()) {
      setAskForName(true);
    }
  }

  function sendNameUpdate() {
    dispatch(updateUsername(anonName));
    setAskForName(false);
  }

  return (
    <div className={styles.engagementBarContainer}>
      <ConditionalTooltip
        content="Play the video to react and comment!"
        showTooltip={componentDisabled}
      >
        <div className={styles.engagementBar}>
          {!askForName && (
            <>
              {emojiEnabled && (
                <div className={styles.engagementSection}>
                  {Object.values(EMOJI_REACTIONS_MAP)
                    .filter(filterNervous)
                    .map(type => (
                      <EmojiIconButton
                        disabled={componentDisabled}
                        key={type}
                        type={type}
                        onClick={checkAnonName}
                      />
                    ))}
                </div>
              )}
              {emojiEnabled && showCommentButton && (
                <div className={styles.verticalRule} />
              )}
              {showCommentButton && (
                <div className={styles.engagementSection}>
                  <CommentButton
                    disabled={componentDisabled}
                    useTextButton={true}
                    onEmbedPlayer={false}
                    controlBarExpanded={false}
                  />
                </div>
              )}
            </>
          )}
          {askForName && (
            <div className={styles.engagementSection}>
              <TextInput
                data-testid="anon-reaction-name-input"
                autoFocus={true}
                placeholder="Your name..."
                className={styles.anonInput}
                onChange={ev => setAnonName(ev.target.value)}
                onKeyUp={ev => {
                  if (anonName.trim().length && ev.keyCode === ENTER) {
                    sendNameUpdate();
                  }
                }}
              />
            </div>
          )}
        </div>
      </ConditionalTooltip>
    </div>
  );
};

export default EngagementBar;
